import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-corporate-info',
  templateUrl: './corporate-info.component.html',
  styleUrls: ['./corporate-info.component.scss']
})
export class CorporateInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
